import fetch from '../utils/fetch';
import store from '@/vuex';

const TAG = 'notify.js';

export function subscribeNewsListAllMiniAppTemplates() {
  return fetch.get('/notify/api/subscribeNews/listAllMiniAppTemplates');
}

export function subscribeNewsListAllTinyAppTemplates() {
  return fetch.get('/notify/api/subscribeNews/listAllTinyAppTemplates');
}
export function getTmplIds(bizCodes) {
  return fetch.post('/notify/api/subscribeNews/getTemplateByBizCodes', bizCodes);
}

// bizType (string):业务使用类型：INVITE 邀请, SHARE 分享, PROMOTION 推广促销 等 = ['INVITE', 'SHARE', 'PROMOTION'],
// page (string, optional):小程序页面地址 ,
// scene (string): 场景参数
// bizType (string):业务使用类型：INVITE 邀请, SHARE 分享, PROMOTION 推广促销 等 = ['INVITE', 'SHARE', 'PROMOTION'],
// page (string, optional):小程序页面地址 ,
// scene (string): 场景参数
export function qrcodeGetWxAcode(bizType = 'SHARE', page = 'pages/goods/goods', scene = '') {
  const postData = {
    bizType,
    page,
    scene,
  };
  return fetch.post('/notify/api/qrcode/getWxAcode', postData);
}

export function qrcodeLongToShort(param) {
  return fetch.get(`/notify/api/qrcode/longToShort?param=${param}`);
}

export function qrcodeShortToLong(param) {
  return fetch.get(`/notify/api/qrcode/shortToLong?param=${param}`);
}
// 微信端调用
export function subscribeNewsReportSubscribe(templateIds = []) {
  try {
    const openId = store.state.openId;
    if (openId && templateIds && templateIds.length > 0) {
      const postData = {
        openId: store.state.openId,
        templateIds,
      };
      return fetch.post('/notify/api/subscribeNews/reportSubscribe', postData);
    }
  } catch (e) {}
}
// 支付宝端调用
export function subscribeNewsReportAliSubscribe(templateIds = []) {
  try {
    const userId = store.state.alipayUserId;
    if (userId && templateIds && templateIds.length > 0) {
      const postData = {
        userId,
        templateIds,
      };
      return fetch.post('/notify/api/subscribeNews/reportAliSubscribe', postData);
    }
  } catch (e) {}
}
// 支付宝端模板【长期订阅】上传
export function reportLongSubscribeAliPay(templateIds = []) {
  try {
    const userId = store.state.alipayUserId;
    if (userId && templateIds && templateIds.length > 0) {
      const postData = {
        userId,
        templateIds,
      };
      return fetch.post('/notify/api/subscribeNews/reportLongTermSubscribe', postData);
    }
  } catch (e) {}
}
// 支付宝端模板是否有【长期订阅】查询
export function subscribeNewsGetLongTermSubscribeLog(templateIds = []) {
  try {
    const userId = store.state.alipayUserId;
    if (userId && templateIds.length > 0) {
      return fetch.post('/notify/api/subscribeNews/getLongTermSubscribeLog', templateIds);
    }
  } catch (e) {
  }
}
// 上报form表单
//  "bizType": "WAIT_PAY",
export function formNewsAddFormNewsRecord(bizId = '', formId = '', bizType = '') {
  try {
    if (!formId) {
      console.log(TAG, 'reportFormNewsRecord formId 不存在或者未空, return !!!');
      return;
    }
    const userId = store.state.alipayUserId;
    if (userId) {
      const postData = {
        bizId,
        formId,
        bizType,
        openId: userId,
      };
      return fetch.post('/notify/api/formNews/addFormNewsRecord', postData);
    }
  } catch (e) {
    console.log(TAG, 'reportFormNewsRecord', e);
  }
}
// 用户订阅记录上报
export function onceSubscribeMsgUserSubscribeSubmit(postData) {
  return fetch.post('/notify/api/onceSubscribeMsg/userSubscribeSubmit', postData);
}
